import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PageHeader, Dropdown, Menu, Button, Modal, message } from 'antd';
import { EditOutlined, PlusOutlined, SettingOutlined, DeleteOutlined, EllipsisOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest';
import * as ToolPermission from '../../tools/ToolPermission';

import SpinFull from '../../components/SpinFull';
import SuperTable from '../../components/SuperTable';

const { confirm } = Modal;

export default function CompanyViewScreen() {
  const history = useHistory();
  const userPermissionsData = useSelector(state => state.userPermissions);

  const isRootAdmin = ToolPermission.hasPermission(userPermissionsData, 'ui:company', 'get:xc');

  const [loaded, setLoaded] = useState(false);
  const [tableKey, setTableKey] = useState(Math.random().toString());

  const columns = [
    {
      template: 'action',
      key: 'action',
      width: 80,
      render: (value, record) => {
        return (
          <Dropdown
            overlay={
              <Menu
                onClick={menuInfo => {
                  switch (menuInfo.key) {
                    case 'edit': {
                      history.push(`/company/edit/${record.id}`);
                      break;
                    }
                    case 'setting': {
                      history.push(`/company/setting/${record.id}`);
                      break;
                    }
                    case 'delete': {
                      onDeleteCompany(record);
                      break;
                    }
                  }
                }}
              >
                <Menu.Item key="edit">
                  <EditOutlined />
                  Edit
                </Menu.Item>
                <Menu.Item key="setting">
                  <SettingOutlined />
                  Settings
                </Menu.Item>
                <Menu.Item key="delete">
                  <DeleteOutlined />
                  Delete
                </Menu.Item>
              </Menu>
            }
          >
            <Button
              type="default"
              shape="round"
            >
              <EllipsisOutlined />
            </Button>
          </Dropdown>
        );
      },
    },
    {
      template: 'id',
      key: 'id',
      width: 40,
      title: 'ID',
    },
    {
      key: 'name',
      title: 'Name',
    },
    {
      key: 'displayName',
      title: 'Display Name',
    },
  ];

  const loadDataSource = async (body) => {
    const companyRes = await ToolRequest.request('GET', '/v1/company', body);

    return {
      data: companyRes.data,
      totalCount: companyRes.totalCount,
    };
  };

  const reloadTable = () => {
    setTableKey(Math.random().toString());
  };

  const onDeleteCompany = (company) => {
    confirm({
      title: 'Are you sure you want to delete this company?',
      content: `Company: ${company.displayName}`,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await ToolRequest.request('DELETE', `/v1/company/${company.id}`);
          message.success('Delete Company successfully');
          reloadTable();
        } catch (err) {
          if (err?.response?.data) {
            switch (err.response.data) {
              case 'DELETE_ROOT_COMPANY_NOT_ALLOWED':
                return message.error('Root company cannot be deleted');
              default:
                return message.error('Unknown errors. Please retry');
            }
          }

          message.error('Unknown error. Please retry');
        }
      },
    });
  };

  useEffect(() => {
    setLoaded(true);
  }, []);

  if (!isRootAdmin) {
    return <SpinFull />;
  }

  return loaded ? (
    <PageHeader
      title="Company List"
      extra={[
        <Button
          key="add-company"
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push('/company/add')}
        >
          Add Company
        </Button>,
      ]}
    >
      <SuperTable
        tableKey={tableKey}
        onTableKeyChange={key => setTableKey(key)}
        loadDataSource={loadDataSource}
        columns={columns}
      />
    </PageHeader>
  ) : <SpinFull />;
}

